import { render, staticRenderFns } from "./InfiniteSelect.vue?vue&type=template&id=56845a4e&"
import script from "./InfiniteSelect.vue?vue&type=script&lang=js&"
export * from "./InfiniteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports